import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  imports: [ImageCropperComponent],
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrl: './image-cropper-dialog.component.scss',
})
export class ImageCropperDialogComponent {
  imageCropper: ImageCropperComponent;
  title: string = 'Bild zuschneiden';
  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  aspectRatio = 1 / 1;
  roundCropper = false;
  height = 150;
  containWithinAspectRatio = false;
  onlyScaleDown = true;
  format: 'png' | 'jpeg' | 'bmp' | 'webp' | 'ico' = 'webp';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    const dialogData = this.config.data ?? {};

    this.imageChangedEvent = dialogData.imageChangedEvent ?? null;
    this.aspectRatio = dialogData.aspectRatio ?? 1 / 1;
    this.roundCropper = dialogData.roundCropper ?? false;
    this.height = dialogData.height ?? 150;
    this.containWithinAspectRatio =
      dialogData.containWithinAspectRatio ?? false;
    this.onlyScaleDown = dialogData.onlyScaleDown ?? true;
    if (this.isOutputFormat(dialogData.format)) {
      this.format = dialogData.format;
    }
  }

  private isOutputFormat(
    value: unknown
  ): value is 'png' | 'jpeg' | 'bmp' | 'webp' | 'ico' {
    return (
      value === 'png' ||
      value === 'jpeg' ||
      value === 'bmp' ||
      value === 'webp' ||
      value === 'ico'
    );
  }

  imageCropped(event: ImageCroppedEvent) {
    const reader = new FileReader();
    reader.onload = () => {
      this.croppedImage = reader.result;
    };
    reader.readAsDataURL(event.blob);
  }

  imageLoaded() {}

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  onSave(): void {
    this.dialogRef.close(this.croppedImage);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
